export const SKIP_WHEN_LOGGED_IN: string[] = [
  "/checkout/hosting/starter/create-account",
];
